import test from './components/test';
import { headerHamburger } from './components/header';
import btt from './components/btt';
import imageChanger from './components/imageChanger';
import odometer from './components/odometer';
import passwordToggle from './components/passwordToggle';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    test();
    headerHamburger();
    passwordToggle();
    odometer();
    btt();
    imageChanger();
  },
  false,
);
